export default "__VITE_ASSET__caf54595__"